<!--
 * @Author: yeqing
 * @Date: 2021-11-24 11:18:36
 * @LastEditTime: 2022-10-18 10:44:46
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @Description: 经济效益组件
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\littleGiant\components\economicBenefitModel.vue
-->
<template>
	<div class="economicBenefitModel">
		<a-form>
			<a-form-item label="1、企业年度营业收入和研发费用的占比" class="block">
				<a-radio-group name="radioGroup" v-model="economicBenefit.q531">
					<a-radio
						:style="radioStyle"
						value="上年度营业收入在1亿元及以上，且近2年研发经费支出占营业收入比重不低于3%"
					>上年度营业收入在1亿元及以上，且近2年研发经费支出占营业收入比重不低于3%</a-radio>
					<a-radio
						:style="radioStyle"
						value="上年度营业收入5000万元（含）—1亿元（不含），且近2年研发经费支出占营业收入比重不低于6%"
					>上年度营业收入5000万元（含）—1亿元（不含），且近2年研发经费支出占营业收入比重不低于6%</a-radio>
					<a-radio
						:style="radioStyle"
						value="上年度营业收入不足5000万元，同时近2年内新增股权融资额（实缴）8000万元（含）以上，且研发投入经费3000万元（含）以上，研发人员占企业职工总数比例50%（含）以上"
					>上年度营业收入不足5000万元，同时近2年内新增股权融资额（实缴）8000万元（含）以上，且研发投入经费3000万元（含）以上，研发人员占企业职工总数比例50%（含）以上</a-radio>
					<a-radio
						:style="radioStyle"
						value="不满足上述指标"
					>不满足上述指标</a-radio>
				</a-radio-group>
			</a-form-item>
			<a-form-item label="2、截止上年末，企业从事特定细分市场时间是否达到3年及以上，且主营业务收入占营业收入达70%以上">
				<a-radio-group name="radioGroup" v-model="economicBenefit.q532">
					<a-radio value="是">是</a-radio>
					<a-radio value="否">否</a-radio>
				</a-radio-group>
			</a-form-item>
			<a-form-item label="3、产品在细分市场占有率是否位于全省前3位，国内细分行业中享有较高知名度和影响力">
				<a-radio-group name="radioGroup" v-model="economicBenefit.q533">
					<a-radio value="是">是</a-radio>
					<a-radio value="否">否</a-radio>
				</a-radio-group>
			</a-form-item>
			<a-form-item label="4、是否近2年主营业务收入或净利润的平均增长率达到5%以上，且企业资产负债率不高于70%">
				<a-radio-group name="radioGroup" v-model="economicBenefit.q534">
					<a-radio value="是">是</a-radio>
					<a-radio value="否">否</a-radio>
				</a-radio-group>
			</a-form-item>
			<div style="text-align: center; margin-top: 40px;">
				<a-button class="primary-btn pre-btn" @click="handlePre">上一步</a-button>
				<a-button class="primary-btn" @click="handleSubmit" :loading="loading">获取报告</a-button>
			</div>
		</a-form>
	</div>
</template>

<script>
export default {
	name: "economicBenefitModel",
	props: {
		loading: Boolean
	},
	data() {
		return {
			economicBenefit: {
				q531: '',
				q532: '',
				q533: '',
				q534: '',
			},
			radioStyle: {
				display: 'block',
				marginTop: '12px'
			},
		};
	},
	methods: {
		// 上一步
		handlePre(e) {
			e.preventDefault();
			this.$emit("changeTabKey", { name: 'economicBenefit', key: 2, data: this.economicBenefit });
		},

		// 立即测评
		handleSubmit(e) {
			e.preventDefault();
			this.$emit("handleSubmit", this.economicBenefit);
		},

	},

};
</script>
<style lang="less" scoped>
.economicBenefitModel {
	margin-top: 30px;
	::v-deep .ant-form-item{
        margin-bottom: 6px;
    }
	::v-deep .ant-form-item-label > label {
		color: #333333;
		font-size: 14px;
		// font-family: PingFangSC-Regular, PingFang SC;
	}
	::v-deep .ant-radio-wrapper {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
	}
	.primary-btn {
		width: 133px;
		height: 40px;
		border-radius: unset;
		background: #0072f7;
		border-radius: 2px;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #ffffff;
		line-height: 16px;
		border: none;
		&:hover {
			color: #fff;
			background-color: #40a9ff;
			border-color: #40a9ff;
		}
	}
	.pre-btn {
		background: #fff;
		color: #999;
		margin-right: 20px;
		border: 1px solid #eeeeee;
		&:hover {
			background-color: #fff;
			color: #40a9ff;
			border-color: #40a9ff;
		}
	}
	.block {
		::v-deep.ant-form-item-control-wrapper {
			display: block;
		}
	}
}
</style>